import groupBy from "lodash/fp/groupBy";

class Controller {
  constructor($mdDialog, Events, Captain, captainName) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.Events = Events;
    this.Captain = Captain;
    this.captainName = captainName;

    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;

    this.confirmEvent = this.Events.getUpdateEvent("confirmDeactivation");

    this.checkedReasons = {
      termination: [],
      churn: [],
    };
  }

  $onInit() {
    this.Events.on(this.confirmEvent, this.confirm.bind(this));

    this.Captain.getDeactivationReasons({
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        const groupByCategory = groupBy("category");
        this.deactivationReasons = groupBy("type")(response.data);
        this.deactivationReasons.churn = groupByCategory(
          this.deactivationReasons.churn
        );
        this.deactivationReasons.termination = groupByCategory(
          this.deactivationReasons.termination
        );
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  confirm() {
    const { deactivationType } = this;
    const reasonsTitle = [
      ...this.checkedReasons.churn,
      ...this.checkedReasons.termination,
    ]
      .map(({ name }) => name)
      .join(", ");
    const confirm = this.$mdDialog
      .confirm()
      .multiple(true)
      .title(
        `Are you sure you want to de-activate
        captain "${this.captainName}" with the following details?`
      )
      .htmlContent(
        `<h4 class="mb-0">Reasons</h4>
        <p class="mt-1">${reasonsTitle}</p>
        <h4 class="mb-0">Note</h4>
        <p class="mt-1">${this.deactivationNote}</p>
      `
      )
      .ok("Confirm")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(() => {
      const reasons = [
        ...this.checkedReasons.churn,
        ...this.checkedReasons.termination,
      ].map(({ key }) => key);
      this.$mdDialog.hide({
        type: deactivationType,
        reasons,
        note: this.deactivationNote,
      });
    });
  }

  close() {
    this.$mdDialog.cancel();
  }

  trackReason(reason) {
    if (reason.checked) {
      this.checkedReasons[reason.type].push(reason);
    } else {
      const reasonIndex = this.checkedReasons[reason.type].indexOf(reason);
      if (reasonIndex > -1) {
        this.checkedReasons[reason.type].splice(reasonIndex, 1);
      }
    }
  }

  isReasonsEmpty() {
    const reasonsArray = [
      ...this.checkedReasons.churn,
      ...this.checkedReasons.termination,
    ];
    return reasonsArray.length === 0;
  }

  isMaxReasons() {
    const reasonsArray = [
      ...this.checkedReasons.churn,
      ...this.checkedReasons.termination,
    ];
    return reasonsArray.length === 5;
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/pages/captain/captainDeactivationDialog/captainDeactivationDialog.controller.js